import * as actions from "./actions";
import { rootRef } from "../../config/firebase";

function asignarColegioAEscuela({ idColegio, values }) {
  return dispatch => {
    let insert = {};
    insert[`escuelas/verano2018/colegios/${idColegio}`] = true;
    insert[`escuelas/verano2018/precios/${idColegio}`] = values;
    rootRef.update(insert);
  };
}

function obtenerListaColegiosConEscuelas() {
  return dispatch => {
    rootRef.child("escuelas/verano2018/colegios").on("child_added", snap => {
      rootRef.child(`detalles/colegios/${snap.key}`).once("value", snapo => {
        const payload = snapo.val();
        payload.id = snap.key;
        dispatch(actions.obtenerListaColegiosConEscuelas(payload));
      });
    });
  };
}

function eliminarColegioListaEscuelas({ idColegio }) {
  return dispatch => {
    let insert = {};
    insert[`escuelas/verano2018/colegios/${idColegio}`] = null;
    insert[`escuelas/verano2018/precios/${idColegio}`] = null;
    rootRef.update(insert, () =>
      dispatch(actions.eliminarColegioListaEscuelas(idColegio))
    );
  };
}

function limpiarListaColegioEscuelas() {
  return actions.limpiarListaColegioEscuelas();
}

function detachEscuelasListeners() {
  return dispatch => rootRef.child("escuelas/verano2018/colegios").off();
}

function obtenerOpcionesEscuelas() {
  return dispatch => {
    dispatch(obtenerOpcionesEscuelasSinComedor());
    dispatch(obtenerOpcionesEscuelasConComedor());
  };
}

function obtenerOpcionesEscuelasSinComedor() {
  return dispatch =>
    rootRef
      .child(`escuelas/verano2018/opciones/sinComedor`)
      .on("child_added", snap =>
        dispatch(actions.escuelasSinComedor({ key: snap.key, ...snap.val() }))
      );
}

function obtenerOpcionesEscuelasConComedor() {
  return dispatch =>
    rootRef
      .child(`escuelas/verano2018/opciones/conComedor`)
      .on("child_added", snap =>
        dispatch(actions.escuelasConComedor({ key: snap.key, ...snap.val() }))
      );
}

function detachOpcionesEscuelas() {
  return dispatch => {
    rootRef.child(`escuelas/verano2018/opciones/sinComedor`).off();
    rootRef.child(`escuelas/verano2018/opciones/conComedor`).off();
  };
}

function limpiarOpcionesEscuelas() {
  return dispatch => {
    dispatch(actions.limpiarEscuelasConComedor());
    dispatch(actions.limpiarEscuelasSinComedor());
  };
}

/*---*/
export {
  asignarColegioAEscuela,
  obtenerListaColegiosConEscuelas,
  detachEscuelasListeners,
  limpiarListaColegioEscuelas,
  eliminarColegioListaEscuelas,
  obtenerOpcionesEscuelas,
  detachOpcionesEscuelas,
  limpiarOpcionesEscuelas
};



// WEBPACK FOOTER //
// ./src/ducks/escuelas/operations.js